import * as React from "react";
const SvgFiRrBarberShop = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-barber-shop_svg__a)">
      <path
        fill="#062147"
        d="M11.828 16.462a53.5 53.5 0 0 1-3.685-5.776C9.665 7.709 11 4.189 11 1a1 1 0 0 0-2 0 18.7 18.7 0 0 1-1.995 7.431A18.7 18.7 0 0 1 5 1a1 1 0 0 0-2 0c0 3.174 1.342 6.7 2.868 9.685a51 51 0 0 1-3.695 5.777A3.986 3.986 0 1 0 7 22.618a3.985 3.985 0 1 0 4.828-6.156M4 22a2 2 0 1 1 0-4 2 2 0 0 1 0 4m.883-5.895a50 50 0 0 0 2.122-3.342c.784 1.35 1.534 2.5 2.117 3.341A4 4 0 0 0 7 17.382a4 4 0 0 0-2.117-1.277M10 22a2 2 0 1 1 0-4 2 2 0 0 1 0 4m8-16v2h5a1 1 0 1 1 0 2h-5v2h5a1 1 0 0 1 0 2h-5v2h5a1 1 0 0 1 0 2h-5v5a1 1 0 0 1-2 0V5a5.006 5.006 0 0 1 5-5h2a1 1 0 1 1 0 2h-2a3 3 0 0 0-2.816 2H23a1 1 0 1 1 0 2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-barber-shop_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBarberShop;
